// extracted by mini-css-extract-plugin
module.exports = {"root":"dashboardPageChrome_root__2_Kos"};